const KAKAO_MAP_SCRIPT_ID = "kakao-map-sdk";

let kakaoMapLoadPromise = null;

export const loadKakaoMapSdk = ({ appKey, libraries = [] } = {}) => {
    const kakaoAppKey = appKey || process.env.VUE_APP_KAKAO_JAVASCRIPT_KEY;
    const needsServices = libraries.includes("services");

    if (!kakaoAppKey) {
        return Promise.reject(
            new Error("VUE_APP_KAKAO_JAVASCRIPT_KEY 환경변수를 설정해주세요.")
        );
    }

    if (
        window.kakao &&
        window.kakao.maps &&
        window.kakao.maps.Map &&
        (!needsServices || window.kakao.maps.services)
    ) {
        return Promise.resolve(window.kakao);
    }

    if (window.kakao && window.kakao.maps && window.kakao.maps.Map && needsServices) {
        return Promise.reject(
            new Error("카카오 지도 SDK가 services 라이브러리 없이 먼저 로드되었습니다.")
        );
    }

    if (window.kakao && window.kakao.maps) {
        return new Promise((resolve) => {
            window.kakao.maps.load(() => resolve(window.kakao));
        });
    }

    if (kakaoMapLoadPromise) {
        return kakaoMapLoadPromise;
    }

    const existingScript = document.getElementById(KAKAO_MAP_SCRIPT_ID);

    kakaoMapLoadPromise = new Promise((resolve, reject) => {
        const onLoad = () => {
            window.kakao.maps.load(() => resolve(window.kakao));
        };
        const onError = () => {
            kakaoMapLoadPromise = null;
            reject(new Error("카카오 지도 SDK 로드에 실패했습니다."));
        };

        if (existingScript) {
            if (needsServices && !existingScript.src.includes("libraries=services")) {
                kakaoMapLoadPromise = null;
                reject(new Error("카카오 지도 SDK가 services 라이브러리 없이 로드 중입니다."));
                return;
            }

            existingScript.addEventListener("load", onLoad, { once: true });
            existingScript.addEventListener("error", onError, { once: true });
            return;
        }

        const script = document.createElement("script");
        const libraryQuery = libraries.length ? `&libraries=${libraries.join(",")}` : "";

        script.id = KAKAO_MAP_SCRIPT_ID;
        script.src = `//dapi.kakao.com/v2/maps/sdk.js?appkey=${kakaoAppKey}&autoload=false${libraryQuery}`;
        script.async = true;
        script.onload = onLoad;
        script.onerror = onError;
        document.head.appendChild(script);
    });

    return kakaoMapLoadPromise;
};
